import * as React from "react";
import ProfileSection from "@common/ProfileSection";
import { TextField, InputAdornment, IconButton } from "@material-ui/core";
import { Clear as ClearIcon, Search as FilterIcon } from "@material-ui/icons";
import { Subheading } from "@components";
import FilterSectionList from "./FilterSectionList";

type Props<T> = {
  children?: (
    items: Array<{ item: T; selected: boolean }>,
    search: string
  ) => React.ReactNode;
  filter?: (item: T, text: string) => boolean;
  itemKey?: (item: T) => string;
  items: T[];
  onToggle?: (item: T) => void;
  renderItem?: (item: T, search: string, selected: boolean) => React.ReactNode;
  renderTitle?: (renderProps: { filter: React.ReactNode }) => React.ReactNode;
  selectedItems: T[];
  title: string;
};

type State = { text: string };

class FilterSection<T> extends React.Component<Props<T>, State> {
  static defaultProps: Partial<Props<any>> = {
    filter: (item, text) =>
      JSON.stringify(item).toLowerCase().includes(text.toLowerCase())
  };

  state: State = { text: "" };

  render() {
    const {
      title: titleProp,
      items,
      children,
      filter: filterProp,
      renderTitle,
      selectedItems
    } = this.props;
    const { text } = this.state;

    const rows = items
      .map((item) => ({ item, selected: selectedItems.includes(item) }))
      // .sortBy(x => !x.selected)
      .filter((i) => i.selected || filterProp(i.item, text));

    const filter = this.renderFilter();

    const title = renderTitle ? (
      renderTitle({ filter })
    ) : (
      <>
        <Subheading>{titleProp}</Subheading>
        <div style={{ marginLeft: "auto" }}>{this.renderFilter()}</div>
      </>
    );

    return (
      <ProfileSection fitted collapsible={false} title={title}>
        {children ? children(rows, text) : this.renderDefaultList(rows)}
      </ProfileSection>
    );
  }

  private renderFilter = () => {
    const { text } = this.state;

    const endAdornment = (
      <InputAdornment position="end">
        <IconButton onClick={() => this.setState((s) => ({ text: "" }))}>
          {text ? <ClearIcon /> : <FilterIcon />}
        </IconButton>
      </InputAdornment>
    );

    return (
      <div style={{ float: "right" }}>
        <TextField
          value={text}
          onChange={({ target: { value } }) => this.setState((s) => ({ text: value }))}
          InputProps={{
            endAdornment
          }}
        />
      </div>
    );
  };

  private renderDefaultList = (rows: Array<{ item: T; selected: boolean }>) => {
    const { itemKey, renderItem, onToggle } = this.props;
    const { text } = this.state;

    return (
      <FilterSectionList
        items={rows.map((row) => ({
          key: itemKey(row.item),
          name: renderItem(row.item, text, row.selected),
          selected: row.selected,
          onToggle: () => onToggle(row.item)
        }))}
      />
    );
  };
}

export default FilterSection;
